import * as addressConstants from '../baseAddressFields/constants';
import { getSelectPropValues } from '../select/util';
/**
 * Get the label for the region field for use as a form label, given a country.
 *
 * @param country
 */

export var getRegionLabel = function getRegionLabel(country) {
  return country && addressConstants.REGION_LABELS_BY_COUNTRY[country] || addressConstants.REGION_LABELS_BY_COUNTRY.DEFAULT;
};
/**
 * Get the label for the postal field for use as a form label, given a country.
 *
 * @param country
 */

export var getPostalLabel = function getPostalLabel(country) {
  return country && addressConstants.POSTAL_LABELS_BY_COUNTRY[country] || addressConstants.POSTAL_LABELS_BY_COUNTRY.DEFAULT;
};
/**
 * Takes countries as returned by the API and formats them for use in a Select
 * component.
 *
 * @param countries
 * @returns {*}
 */

export var formatCountriesForDropdown = function formatCountriesForDropdown() {
  var countries = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return getSelectPropValues(countries, 'label', 'code');
};
/**
 * Takes regions as returned by the API and formats them for use in a Select
 * component.
 *
 * @param regions
 * @returns {*}
 */

export var formatRegionsForDropdown = function formatRegionsForDropdown() {
  var regions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return getSelectPropValues(regions, 'label', 'code');
};